var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"we__slogan"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('p',{staticClass:"subtitle",domProps:{"innerHTML":_vm._s(_vm.subtitle)}})])}
var staticRenderFns = []

export { render, staticRenderFns }